import React from 'react';
import TableCell from '@mui/material/TableCell';
import { SxProps, Theme } from '@mui/material';
import { style } from '@mui/system';

export const TableCellWrapper = (props: {
    children?: React.ReactNode;
    type?: string;
    style?: SxProps<Theme>;
}) => {
    return (
        <TableCell
            sx={{
                width: props.type == 'name' ? '40%' : '10%',
                ...props.style,
            }}
        >
            {props.children}
        </TableCell>
    );
};
